/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RfqTransactionItem } from '../../models/rfq-transaction-item';

export interface ApiVendorRfqItemGet$Params {
  pk?: string;

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
}

export function apiVendorRfqItemGet(http: HttpClient, rootUrl: string, params?: ApiVendorRfqItemGet$Params, context?: HttpContext): Observable<StrictHttpResponse<RfqTransactionItem>> {
  const rb = new RequestBuilder(rootUrl, apiVendorRfqItemGet.PATH, 'get');
  if (params) {
    rb.query('pk', params.pk, {});
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RfqTransactionItem>;
    })
  );
}

apiVendorRfqItemGet.PATH = '/api/vendor/rfq/Item';
